/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type billing_CancelContractVersionRequest = {
    /**
     * Reason provides the business justification and will be appended to notes
     */
    reason: string;
    /**
     * Strategy defines how the version should be merged into neighbours
     */
    strategy: billing_CancelContractVersionRequest.strategy;
};
export namespace billing_CancelContractVersionRequest {
    /**
     * Strategy defines how the version should be merged into neighbours
     */
    export enum strategy {
        EXTEND_PREVIOUS = 'extend_previous',
        EXTEND_NEXT = 'extend_next',
    }
}

